export default "__VITE_ASSET__CkhO9JgW__"